import { useRef, useState } from "react";
import Box from "@mui/material/Box";
import { Music } from "lucide-react";
import { palette } from "../../theme";

// Bouton de musique flottant — JAMAIS en autoplay.
// Place ton fichier dans public/assets/music.mp3 (ou change `src`).
export default function MusicPlayer({ src = "/assets/music.mp3" }: { src?: string }) {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
    } else {
      a.play()
        .then(() => setPlaying(true))
        .catch(() => setPlaying(false));
    }
  };

  return (
    <>
      <audio ref={audioRef} src={src} loop preload="none" />
      <Box
        component="button"
        type="button"
        onClick={toggle}
        aria-label={playing ? "Couper la musique" : "Écouter la musique"}
        aria-pressed={playing}
        sx={{
          position: "fixed",
          bottom: 22,
          right: 22,
          zIndex: 200,
          width: 54,
          height: 54,
          borderRadius: "50%",
          border: `1px solid ${palette.gold}`,
          backgroundColor: "rgba(255,255,255,0.5)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          color: palette.goldDeep,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
          transition: "transform 0.3s ease, background-color 0.3s ease",
          animation: playing ? "softpulse 2.2s ease-in-out infinite" : "none",
          "&:hover": { transform: "scale(1.08)", backgroundColor: "rgba(255,255,255,0.78)" },
        }}
      >
        {/* Anneau "vinyle" qui tourne pendant la lecture */}
        {playing && (
          <Box
            aria-hidden
            sx={{
              position: "absolute",
              inset: 4,
              borderRadius: "50%",
              border: `1.5px dashed ${palette.gold}`,
              opacity: 0.6,
              animation: "spin 4s linear infinite",
            }}
          />
        )}

        {playing ? (
          // Égaliseur animé
          <Box sx={{ display: "flex", alignItems: "center", gap: "3px", height: 20 }}>
            {[0, 1, 2, 3].map((i) => (
              <Box
                key={i}
                sx={{
                  width: 3,
                  height: 18,
                  borderRadius: 2,
                  backgroundColor: palette.goldDeep,
                  transformOrigin: "center",
                  animation: "eq 0.9s ease-in-out infinite",
                  animationDelay: `${i * 0.15}s`,
                }}
              />
            ))}
          </Box>
        ) : (
          <Music size={20} strokeWidth={1.6} />
        )}
      </Box>
    </>
  );
}
